import type React from "react";
import type { FieldGroupProps } from "ui/Form/Element/FieldGroup";
import type { FieldControlProps } from "ui/Form/Element/FieldControl";
import type { LabelProps } from "ui/Form/Element/Label";

export const profileLabelClassName = "mb-2 block text-sm font-semibold text-gray-900";

export const profileFieldGroupClassName = "space-y-2";

export const profileInputClassName =
    "h-11 w-full rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-900 shadow-none transition-colors placeholder:text-slate-400 focus:border-primary focus:outline-none focus:ring-2 focus:ring-ring/30";

export const profileTextareaClassName =
    "min-h-[160px] w-full resize-y rounded-xl border border-gray-200 bg-slate-50 px-4 py-3 text-sm leading-relaxed text-gray-900 shadow-none transition-colors placeholder:text-slate-400 focus:border-primary focus:bg-white focus:outline-none focus:ring-2 focus:ring-ring/30";

export function profileLabelProps(label: React.ReactNode, required?: boolean): LabelProps & { label: React.ReactNode } {
    return {
        label,
        className: profileLabelClassName,
        required,
    };
}

export function profileFieldGroupProps(className?: string): FieldGroupProps {
    return {
        className: [profileFieldGroupClassName, className].filter(Boolean).join(" "),
    };
}

export function profileFieldControlProps(className?: string): FieldControlProps {
    return {
        className: [className].filter(Boolean).join(" "),
    };
}
